module.exports = __webpack_public_path__ + "img/grid-blog-3.5dca9f94.png";